"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ordersStore = void 0;
var types_1 = require("./types");
var OrdersStore = /** @class */ (function () {
    function OrdersStore() {
        this.orders = {};
        this.loadOrders();
    }
    OrdersStore.prototype.addOrder = function (chainId, order) {
        // console.log("Adding order to localstorage", order, "to chain", chainId);
        var chainOrders = this.orders[chainId.toString()] || [];
        this.orders[chainId.toString()] = __spreadArray([order], chainOrders, true);
        this.saveOrders();
    };
    OrdersStore.prototype.deleteOrder = function (chainId, orderId) {
        // console.log("Got order from api, Deleting order from localstorage", orderId, "from chain", chainId);
        var chainOrders = this.orders[chainId.toString()] || [];
        this.orders[chainId.toString()] = chainOrders.filter(function (order) { return order.id !== orderId; });
        this.saveOrders();
    };
    OrdersStore.prototype.saveOrders = function () {
        localStorage.setItem("twap-orders", JSON.stringify(this.orders));
    };
    OrdersStore.prototype.cancelOrder = function (chainId, orderId) {
        console.log("Cancelling order", orderId);
        var chainOrders = this.orders[chainId.toString()] || [];
        this.orders[chainId.toString()] = chainOrders.map(function (order) {
            if (order.id === orderId) {
                return __assign(__assign({}, order), { status: types_1.Status.Canceled });
            }
            return order;
        });
    };
    OrdersStore.prototype.loadOrders = function () {
        var storedOrders = localStorage.getItem("twap-orders");
        if (storedOrders) {
            this.orders = JSON.parse(storedOrders);
        }
    };
    return OrdersStore;
}());
exports.ordersStore = new OrdersStore();
